import { render, staticRenderFns } from "./siteSetting.vue?vue&type=template&id=0421a5c5&scoped=true&"
import script from "./siteSetting.vue?vue&type=script&lang=js&"
export * from "./siteSetting.vue?vue&type=script&lang=js&"
import style0 from "./siteSetting.vue?vue&type=style&index=0&id=0421a5c5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421a5c5",
  null
  
)

export default component.exports